import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  InfoAboutAction, 
  setIsFetching, 
  setFetchFailed, 
  setAboutContent,
} from 'Components/InfoAbout/Redux/actions';

export const fetchAboutContent = () => {
  return async (dispatch: Dispatch<InfoAboutAction>): Promise<void> => {
    const { isFetching, content } = Store.getState().infoAbout;

    if (isFetching || content) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('AboutPage');

      if (response.status !== 200) {
        dispatch(setFetchFailed());
      } else {
        const newContent: Julius.Website.AboutPageViewModel = await response.json();
        dispatch(setAboutContent(newContent));
      }
      
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/InfoAbout/Redux/thunks.tsx